import AdminShell from "../../components/AdminShell";
import { Construction } from "lucide-react";
export default function AdminTestimonials() {
  return (
    <AdminShell title="Testimonials" subtitle="Coming soon — Phase 2">
      <div className="bg-white border border-slate-200 rounded-xl py-20 text-center">
        <Construction size={40} className="mx-auto text-slate-300 mb-4" />
        <div className="font-semibold text-slate-600">Under construction</div>
        <div className="text-sm text-slate-400 mt-1">This section is being built next.</div>
      </div>
    </AdminShell>
  );
}
